import { render, staticRenderFns } from "./homeleft.vue?vue&type=template&id=6b5f9be6&scoped=true"
import script from "./homeleft.vue?vue&type=script&lang=js"
export * from "./homeleft.vue?vue&type=script&lang=js"
import style0 from "./homeleft.vue?vue&type=style&index=0&id=6b5f9be6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5f9be6",
  null
  
)

export default component.exports